module.exports = __webpack_public_path__ + "static/media/icon_chart.0f7a1c3f.svg";